import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

export default function HowCalculated({ storageKey, label = 'How this is calculated', testId, children }) {
  const [open, setOpen] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      const k = `apex-lens-howcalc-${storageKey}`;
      const seen = window.localStorage.getItem(k);
      if (!seen) { setOpen(true); window.localStorage.setItem(k, '1'); }
    } catch {}
    setReady(true);
  }, [storageKey]);

  if (!ready) return null;

  return (
    <div data-testid={testId} className="mt-4 border border-slate-200 rounded-lg bg-white overflow-hidden">
      <button onClick={() => setOpen(v => !v)} data-testid={`${testId}-toggle`}
        className="w-full flex items-center justify-between px-4 py-2.5 text-[10px] uppercase tracking-wider font-semibold text-apex-neutral hover:bg-slate-50 transition-colors">
        <span>{label}</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.25 }} className="overflow-hidden">
            <div className="px-4 pb-4 pt-1 text-[12px] leading-relaxed text-apex-ink-2">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
